import { GoldButton as CompGoldButton } from 'components/Button'
import I18n from 'components/I18n'
import { actions } from 'data'
import { ReasonNotEligible } from 'data/Eligibility/types'
import messages from 'lang'
import React from 'react'
import { useDispatch } from 'react-redux'
import EUSanctions from 'scenes/App/OnBootMessages/EligibilityNotifications/EUSanctions'
import Restriction from 'scenes/App/OnBootMessages/EligibilityNotifications/Restriction'
import styled from 'styled-components'

const GoldButton = styled(CompGoldButton)`
  width: 100%;
  margin-top: 1rem;
`

type Props = {
  context: 'DEPOSIT' | 'WITHDRAW'
  reason?: ReasonNotEligible
}

const EligibilityNotifications = ({ context, reason }: Props) => {
  const dispatch = useDispatch()
  const openGoldModal = () => {
    dispatch(actions.app.showModal('TIER_TWO'))
    dispatch(
      actions.analytics.trackEvent({
        key: 'Upgrade Verification Clicked',
        properties: {
          origin: context,
          tier: 2
        }
      })
    )
  }

  // If we got no reason we assume tier 2
  if (!reason || reason.reason === 'TIER_2_REQUIRED') {
    return (
      <>
        <p>
          <I18n data={messages.unlock_gold_description_no_currency} />
        </p>
        <GoldButton e2e='unlockGoldModalButton' onClick={openGoldModal}>
          <I18n data={messages.unlock_gold_apply} />
        </GoldButton>
      </>
    )
  }

  if (reason.reason === 'EU_5_SANCTION') {
    return (
      <EUSanctions>
        <I18n data={messages.account_restricted_desc_generic} />
      </EUSanctions>
    )
  }

  // Something else, we don't know exactly what so we show BE error
  return <Restriction>{reason.message}</Restriction>
}

export default EligibilityNotifications
